import Review from "../disease/review";
import reviews from "../../repo/reviews";

import template from './index.tpl';
import './index.css';
import YourReview from "./yourreview";
import ProtectedContent from "../authenticator/protected-content";
import Identity from "../../repo/identity";

export default DomClass(template, async function Disease() {
	const _t = this;

	this.reviews = "Fetching reviews ... ";
	this.editLink = "?edit/" + this.normalizedName;

	reviews.listByDisease(_t.normalizedName).then(reviews => {
		_t.reviews = reviews
			.filter(review => review.owner != Identity.username)
			.map((review) => new Review({
				...review,
				disease: _t
			}))
		;
	});

	reviews.getMine(_t.normalizedName).then(r => {
		r = r || {};
		r.diseaseNormalizedName = _t.normalizedName;
		_t.userReview = new ProtectedContent({
			content: new YourReview({
				...r,
				disease: _t
			}),
			error: "<i>Sign in to post a review!</i>"
		});
	});

});
